import { PrimaryKeyId } from "./brands.model";

export enum ReportTemplateType {
  customReport = "customReport",
  defaultReport = "defaultReport",
}

export type ReportTemplate = {
  readonly templateId: PrimaryKeyId;
  readonly lastModified: Date;
  readonly type: ReportTemplateType;
  readonly preview: any[];
  readonly storageToken: string;
  /** Template report name */
  templateName: string;
};

export type ReportTemplateData = {
  readonly templateId: PrimaryKeyId;
  lastModified: Date;
  templateName: string;
  items: any[];
};
